import styled from '@emotion/styled';
import profile from '../../assets/img/profile.png';
import { theme } from '../../2022-component-library';

const StyledRangeSlider = styled.input`
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent;
  &:-webkit-slider-thumb {
    -webkit-appearance: none;
  }
  &:focus {
    outline: none;
  }
  &:-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent;
    color: transparent;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 28px;
    height: 28px;
    border-radius: ${(props) => (props.video ? '0%' : '50%')};
    border: 0;
    margin-top: 6px;
    background: ${(props) => (props.video ? `url(${profile})` : '#000')};
    cursor: pointer;
  }
  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 44px;
    cursor: pointer;
    border: 1px solid ${theme.colors.primary};
    border-radius: 12px;
    padding: 0px 10px;
  }
  &::-moz-range-track {
    width: 100%;
    height: 44px;
    cursor: pointer;
    border-radius: 1.3px;
    border: 1px solid ${theme.colors.primary};
    border-radius: 12px;
    padding: 0px 10px;
  }
  ::-moz-range-thumb {
    width: 28px;
    height: 28px;
    border-radius: ${(props) => (props.video ? '0%' : '50%')};
    border: 0;
    margin-top: 6px;
    background: ${(props) => (props.video ? `url(${profile})` : '#000')};
    cursor: pointer;
  }

  ${({ smallScreen }) =>
    smallScreen &&
    `&::-webkit-slider-runnable-track {
    height: 15px;
    border: none;
    border-radius: 5px;
    padding: 0px 10px;
    background-color: ${theme.colors.primary};
    outline: none;
  }

  &::-moz-range-track {
    height: 15px;
    cursor: pointer;
    border: none;
    border-radius: 5px
    padding: 0px 10px;
    background-color: ${theme.colors.primary};
    outline: none;}
    &::-webkit-slider-thumb {transform: translateY(-45%); background: #000 }
    &::-moz-range-thumb {transform: translateY(-45%); background: #000 }
  `}
`;

const RangeSlider = ({ min, max, ...props }) => {
  return <StyledRangeSlider min={min} max={max} {...props} />;
};

export default RangeSlider;
